import { render, staticRenderFns } from "./QuestionMulti.vue?vue&type=template&id=7a1a3fb6&"
import script from "./QuestionMulti.vue?vue&type=script&lang=js&"
export * from "./QuestionMulti.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMulti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports